import { MaterialService } from './material.service';
import { AchievementManagerService } from './achievementManager.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ConversationService } from './conversation.service';
import { Group } from './../model/group.model';
import { RoutePermission } from './../model/routePermission.model';
import { RoutePermissionService } from './routePermission.service';
import { GroupService } from './group.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject, empty, throwError } from 'rxjs';
import { filter, map, share, switchMap } from 'rxjs/operators'


import { Router, ActivatedRoute } from '@angular/router';
import { Login } from '../model/login.model';
import { Auth, AuthResponse, SessionExchange, SessionHandoff } from '../model/auth.model';
import { CheckSsoResponse } from '../model/check-sso.model';
import { environment } from '../../../../environments/environment';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { catchError, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Language } from '../model/language.model';
import { SharedAppState } from '../store/app.states';
import { sign } from 'core-js/core/number';
import * as userActions from '../store/actions/user.actions';


@Injectable()
export class AuthenticationService extends KiwixiService {
    // TODO: Verifié que l'overide des variables commenté est bien utilisé
    // auth: Auth;
    // headers: HttpHeaders;
    responseheaders: any;
    // router: Router;
    activatedRoute: ActivatedRoute;
    // kiwixiGlobals: KiwixiGlobals
    private errorMessage: any = '';
    apiMe = environment.me;
    environment = environment;
    apiCalendar = environment.server + 'calendar/export/oauth/token/';
    currentUser: any = null; // persona
    public site;
    public currentUserSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public currentUserAndFormation: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    constructor(
        private _activatedRoute: ActivatedRoute,
        _router: Router,
        private _http: HttpClient,
        kiwixiGlobals: KiwixiGlobals,
        private materialService: MaterialService,
        private groupService: GroupService,
        private routePermissionService: RoutePermissionService,
        private conversationService: ConversationService,
        private deviceDetectorService: DeviceDetectorService,
        private achievementManagerService: AchievementManagerService,
        private store: Store<SharedAppState>
    ) {
        super(_http, _router, kiwixiGlobals, materialService);
        this.router = _router
        this.activatedRoute = _activatedRoute
        this.headers = new HttpHeaders();
        this.kiwixiGlobals = kiwixiGlobals;
        this.checkCredentialObservable();
        this.site = localStorage.getItem('site');
    }

    /**
     * Normalise une adresse e-mail provenant d'URL/query params pour préserver les « + ».
     * Certains navigateurs/flux transforment "+" en espace lors du parsing de querystring.
     * Ici, on re-map les espaces éventuels en "+" pour garder l'email exact.
     */
    private normalizeEmail(email: string | null | undefined): string | null | undefined {
        if (email == null) { return email; }
        // Les emails ne contiennent pas d'espace valide, donc on considère tout espace comme un « + » perdu.
        return email.replace(/\s/g, '+');
    }

    get getHeaders() {
        return this.headers;
    }

    callMe(): Observable<HttpResponse<any>> {
        return this._http.get(
            this.apiMe, { observe: 'response', headers: this.createHttpClientAuthorizationHeader() });
    }

    /**
     *
     * @returns {Observable<T>}
     */
    isLoggedIn(): Observable<boolean> {
        return this.currentUserSubject.asObservable().pipe(share());
    }

    // **************************** IMPERSONATE ****************************
    /**
     * Méthode pour définir le type d'initialisation en fonction de l'authentification : impersonate vs reload page
     * @param role // student ou teacher
     * @param site // lingueopro ou teacher
     */
    initAuthPage(role, site): Observable<any> {
        // #1 - check path
        if (fromImpersonate(this, site)) {
            this.initFromImpersonate(role, site); // chargement de la page loggé via impersonate.
            // Le jeton n'arrive qu'après l'échange du code (asynchrone) : la valeur
            // initiale `null` du sujet ne doit pas afficher l'app, dont les écrans
            // appelleraient l'API sans jeton puis renverraient au login.
            return this.currentUserAndFormation.asObservable().pipe(filter(value => value !== null), share());
        } else if (fromReload(this, role)) {
            this.initFromReload(role);
            return this.currentUserAndFormation.asObservable().pipe(share());
        }

        function fromImpersonate(_self, _site) {
            // Code d'échange remis par l'application d'origine (API-R1).
            return !!(_self.activatedRoute.children[0] &&
                _self.activatedRoute.children[0].snapshot.queryParams &&
                _self.activatedRoute.children[0].snapshot.queryParams['code']);
        }

        function fromReload(_self, _role) {
            if (_role === 'teacher') {
                return true;
            } else if (_role === 'student') {
                if (_self.activatedRoute.children[0] &&
                    _self.activatedRoute.children[0].snapshot.params &&
                    _self.activatedRoute.children[0].snapshot.params.id) {
                    return true;
                }
            }
            return false;
        }

    }

    getRoutesPermissions() {
        let params = new HttpParams();
        params = params.append('salt', Math.random().toString());
        return this.routePermissionService.getRoutePermissions(params);
    }

    getGroups() {
        let params = new HttpParams();
        params = params.append('salt', Math.random().toString());
        return this.groupService.getGroups(params);
    }

    normalizeRoutePath(routePath: string) {
        const re = /\/[0-9]+/
        return routePath.replace(re, '/%s');
    }
    getRoutesAllowed(routePath: string): RoutePermission[] {
        const path = this.normalizeRoutePath(routePath);
        return this.routePermissionService.routeFeaturePermissions.value.filter(e => e.name === path);
    }
    resetFeaturePermissions() {
        this.groupService.appGroups.next(null);
        this.routePermissionService.routeFeaturePermissions.next(null);
    }

    checkGroupPermission(group: Group) {
        if (group.all_user) {
            return true;
        } else {
            const userLogged = this.currentUserSubject.value;
            if (!userLogged) {
                return false;
            }
            const findGroup = userLogged.user.groups.filter(_group => _group.name === group.name);
            if (findGroup.length > 0) {
                return true;
            } else {
                return false;
            }
        }
    }

    checkAvailableLanguageSheets(languageId) {
        return this.availableSheetsLanguage.indexOf(languageId) === -1 ? false : true;
    }

    checkFeaturePermission(groupName) {
        if (!this.groupService.appGroups.value) {
            return false;
        }
        const findGroup = this.groupService.appGroups.value.filter(group => group.name === groupName);
        if (findGroup.length > 0) {
            return this.checkGroupPermission(findGroup[0]);
        } else {
            return false;
        }
    }


    initFromReload(personaType) {
        let _formation_id = null
        if (personaType === 'student') {
            _formation_id = this.activatedRoute.children[0].snapshot.params.id;
        }
        const _obj = { user: this.getCurrentPersona(), formation: _formation_id };
        this.currentUserAndFormation.next(_obj);
    }

    /**
     * Construction du bundle en mode Impersonate
     * @param _role
     * @param _site
     */
    initFromImpersonate(_role, _site) {
        // #1 - on oublie la session précédente.
        ['persona', 'persona_obj', 'x-bundle-recurring', 'access_token', 'sign', 'last_selected_formation_id']
            .forEach(key => localStorage.removeItem(key));

        // #2 - on échange le code remis par l'application d'origine (API-R1) :
        // session liée au site et au rôle de cette application.
        const _params = this.activatedRoute.children[0].snapshot.queryParams;
        this.exchangeCode(_params['code'], { site: _site, role: _role }).pipe(
            switchMap(() => this.callMe())
        ).subscribe(res => {
            localStorage.setItem('persona_obj', JSON.stringify(res.body));
            localStorage.setItem('impersonate', 'true'); // variable definissant le mode impersonate
            localStorage.setItem('formation_id', _params['formation_id']);
            const _obj = { user: res.body, formation: _params['formation_id'] }
            this.currentUserSubject.next(res.body);
            this.currentUserAndFormation.next(_obj);
            const _url = this.site === 'teacher' ? 'upcoming' : '/formation/' + _params['formation_id'];
            this.router.navigate([_url]);
        }, () => {
            // Code refusé ou expiré : l'app s'affiche sans session, sur le login.
            this.currentUserAndFormation.next({ user: null });
            this.router.navigateByUrl('/login');
        })
    }

    setLocalPersonaObj(personna) {
        localStorage.setItem('persona_obj', JSON.stringify(personna));
    }

    _createAuthorizationHeader() {
        const xBundleRecurring = {
            site: this.auth.site,
            language: this.auth.language,
            device: this.auth.device,
            persona: this.auth.persona,
            role: this.auth.role,
            hash: this.auth.hash
        }
        let headers = new HttpHeaders();
        headers = headers.set('x-bundle-recurring', JSON.stringify(xBundleRecurring))
            .set('Authorization', 'Basic ' + btoa(environment.client_id + ':' + environment.application_id))
            .set('Content-Type', 'application/json; charset="utf-8";')
            .set('Access-Control-Allow-Origin', '*')
            .set('Access-Control-Expose-Headers', 'x-bundle-recurring')
            ;
        return headers;
    }

    /**
     * Logout
     */
    logout() {
        // #1 - vide le local storage
        localStorage.removeItem('device');
        localStorage.removeItem('persona');
        localStorage.removeItem('sign');
        localStorage.removeItem('access_token');
        localStorage.removeItem('impersonate');
        localStorage.removeItem('persona_obj');
        localStorage.removeItem('formation_id');
        localStorage.removeItem('x-bundle-recurring');
        localStorage.removeItem('last_selected_formation_id');
        // #2 - on change le statut global du login
        this.kiwixiGlobals.setLoginStatus(false);
        this.currentUserSubject.next(null);
        this.conversationService.conversationList.next([]);
        this.achievementManagerService.achievementToFire.next([]);
    }

    /**
     * Methode pour verifier l'authentification de l'utilisateur.
    **/
    public checkCredentialObservable() {
        const current_time = Date.now();
        this.kiwixiGlobals.last_check_time = current_time;
        const newBundle = JSON.parse(localStorage.getItem('x-bundle-recurring'));
        if (newBundle === null) {
            this.currentUserSubject.next(null);
            return empty();
        }
        const headers = this.createHttpClientAuthorizationHeader();
        return this._http.get(this.apiMe, { headers: headers })
            .pipe(
                map(res => {
                    const body = res;
                    this.extractCredential(body);
                    this.currentUser = body;
                    this.currentUserSubject.next(body);
                    return body;
                }),
                catchError(
                    error => {
                        this.currentUserSubject.next(null);
                        this.kiwixiGlobals.setLoginStatus(false);
                        return this.router.navigate(['/login']);
                        // return Observable.throw(error);
                    }
                )
            );
    }

    newLogin(login: Login): Observable<HttpResponse<AuthResponse>> {
        this.computeAuth(login);
        const headers = this._createAuthorizationHeader();
        const params = {
            grant_type: 'password',
            username: login.username,
            password: login.password,
            signkey: this.auth.sign
        };

        return this._http.post<AuthResponse>(environment.auth, params, { observe: 'response', headers: headers })
            .pipe(
                map(
                    res => {
                        this.responseheaders = res.headers;
                        const access_token = res.body['access_token']
                        localStorage.setItem('x-bundle-recurring', this.responseheaders.get('x-bundle-recurring'));
                        localStorage.setItem('access_token', access_token);
                        this.kiwixiGlobals.last_check_time = -1;
                        return res
                    },
                    error => {
                        this.materialService.openSnackBar('Erreur login !!!', 'red')
                        return error;
                    }
                )
            )

    }

    checkIfIsAdmin(login: Login) {
        this.computeAuth(login);
        const headers = this._createAuthorizationHeader();
        const params = {
            grant_type: 'password',
            username: login.username,
            password: login.password,
            signkey: this.auth.sign
        };
        return this._http.post(environment.auth, params, { observe: 'response', headers: headers })
            .toPromise()
            .then(
                res => {
                    this.responseheaders = res.headers;
                    const access_token = res.body['access_token']
                    localStorage.setItem('x-bundle-recurring', this.responseheaders.get('x-bundle-recurring'));
                    localStorage.setItem('access_token', access_token);
                },
                error => this.materialService.openSnackBar('Erreur login !!!', 'red')
            )
    }

    // private extractAuth(res: Response) {
    //   const body = res.json();
    //   localStorage.setItem('access_token', body.access_token);
    //   // this.router.navigate(['/'])
    //   // this.router.navigate(['/dashboard'])
    // }

    public getDeviceMode() {
        if (this.deviceDetectorService.isDesktop() || this.deviceDetectorService.isTablet()) {
            return 'desktop';
        } else {
            return 'mobile';
        }
    }

    private computeAuth(login: Login) {
        const _site = localStorage.getItem('site');
        const _language = localStorage.getItem('language');
        const _device = this.getDeviceMode();
        const _role = localStorage.getItem('default_role');
        const _persona = login.username;
        this.auth = new Auth(_site, _language, _device, _persona, _role);
        this.auth.setSign();
        localStorage.setItem('sign', this.auth.sign);
        localStorage.setItem('device', this.auth.device);
        localStorage.setItem('persona', this.auth.persona);
        localStorage.setItem('role', this.auth.role);
        this.auth.setLoginHash();
    }

    get getAuth() {
        return this.auth;
    }

    getCurrentPersona() {
        return JSON.parse(localStorage.getItem('persona_obj'));
    }

    getCurrentFormationId() {
        return JSON.parse(localStorage.getItem('formation_id'));
    }

    checkPersona() {
        const _user = this.currentUserSubject.value;
        const _persona = JSON.parse(localStorage.getItem('persona_obj'));
        if (_user && _persona) {
            if (_user && _persona && _user.url && _persona.url && _user.url !== _persona.url) {
                return false;
            }
            return true;
        }
        return true;
    }

    newPassword(email, site) {
        // site
        return this._http.post(environment.server + 'user_reset_password/',
            {
                'email': email,
                'site': site
            }
        ).pipe(
            catchError((error) => { return throwError(() => error); })
        )
    }

    // ************************ CODE D'ÉCHANGE (API-R1) ************************
    /**
     * Code d'ouverture d'une autre application (`POST auth/handoff/`), à passer
     * dans son URL (`?code=`) au lieu du jeton : sur sa propre persona, ou, pour
     * un staff, sur celle de `persona` (email). Sans `site` ni `role`,
     * l'application cible les donne à l'échange.
     */
    handoff(options: { persona?: string, site?: string, role?: string } = {}): Observable<SessionHandoff> {
        const body = {
            ...options,
            language: localStorage.getItem('language') || 'fr',
            device: this.getDeviceMode(),
        };
        return this._http.post<SessionHandoff>(
            environment.server + 'auth/handoff/', body, { headers: this.createHttpClientAuthorizationHeader() }
        );
    }

    /**
     * Échange un code reçu dans l'URL (SSO, impersonation, passage d'une app à
     * l'autre) contre la session, et l'enregistre. `site` et `role` : ceux de
     * l'application, utilisés si l'émetteur ne les a pas fixés.
     */
    exchangeCode(code: string, context: { site?: string, role?: string } = {}): Observable<SessionExchange> {
        const body = {
            code,
            ...context,
            language: localStorage.getItem('language') || 'fr',
            device: this.getDeviceMode(),
        };
        return this._http.post<SessionExchange>(environment.server + 'auth/exchange/', body).pipe(
            tap(session => this.storeExchangedSession(session))
        );
    }

    /** Enregistre une session échangée : jeton, signkey du WebSocket et contexte lié (`bound`). */
    storeExchangedSession(session: SessionExchange) {
        const bundle = session.bundle;
        this.auth = new Auth(bundle.site, bundle.language, bundle.device, bundle.persona, bundle.role);
        this.auth.sign = session.signkey;
        this.auth.session_id = session.session_id;
        localStorage.setItem('access_token', session.access_token);
        localStorage.setItem('sign', session.signkey);
        localStorage.setItem('x-bundle-recurring', JSON.stringify(bundle));
        localStorage.setItem('persona', bundle.persona);
        localStorage.setItem('role', bundle.role);
        localStorage.setItem('device', bundle.device);
    }

    /**
     * Vérifie si le domaine de l'email saisi est routé vers un fournisseur SSO
     * (étape 1 du login). Appel non authentifié (AllowAny côté API).
     *
     * Le site est transmis pour que l'URL SSO renvoyée ramène l'utilisateur sur
     * ce front après authentification, et non sur le site de repli configuré
     * côté fournisseur.
     */
    checkSso(email: string): Observable<CheckSsoResponse> {
        const site = localStorage.getItem('site');
        return this._http.post<CheckSsoResponse>(environment.server + 'auth/check-sso/', { email, site }).pipe(
            catchError((error) => { return throwError(() => error); })
        );
    }

    sendNewPassword(uid, token, password1, password2) {
        // site
        return this._http.post(environment.server + 'new_password/',
            {
                'uid': uid,
                'token': token,
                'password1': password1,
                'password2': password2
            }
        )
            .pipe(
                catchError(this.handleErrorObservable('sendNewPassword', []))
            )
    }

    writeGoogleCalendar(param: any) {
        let params = new HttpParams();
        for (const key of Object.keys(param)) {
            params = params.set(key, param[key]);
        }
        const headers = this.createHttpClientAuthorizationHeader();
        return this._http.post(this.apiCalendar, param, {
            headers: headers
        })
    }

    lilateLogin(login: Login) {
        this.computeAuth(login);
        const headers = this._createAuthorizationHeader();
        const params = {
            grant_type: 'password',
            username: login.username,
            password: login.password,
            signkey: this.auth.sign
        };
        return this._http.post<AuthResponse>(environment.auth, params, { observe: 'response', headers: headers });
    }

    me() {
        return this._http.get(this.apiMe);
    }

    /**
     * Setter & getter for access token
     */
    set accessToken(token: string) {
        localStorage.setItem('access_token', token);
    }

    get accessToken(): string | null {
        return localStorage.getItem('access_token') ? localStorage.getItem('access_token') : null;
    }

    set refreshToken(token: string) {
        localStorage.setItem('refreshToken', token);
    }

    get refreshToken(): string | null {
        return localStorage.getItem('refreshToken') ? localStorage.getItem('refreshToken') : null;
    }

    set xBundleRecurring(bundle: string) {
        localStorage.setItem('x-bundle-recurring', bundle);
    }

    get xBundleRecurring(): string | null {
        return localStorage.getItem('x-bundle-recurring') ? localStorage.getItem('x-bundle-recurring') : null;
    }

    /**
     * Check the authentication status
     */
    check(): Observable<boolean> {
        return this.store.select("auth").pipe(
            map(state => { return state.isAuthenticated; })
        )
    }

    reloadUser(): void {
        this.callMe().subscribe(res => {
            localStorage.setItem('persona_obj', JSON.stringify(res.body));
            this.currentUserSubject.next(res.body);
        })
    }

    reloadUserFromStore(): void {
        this.store.dispatch(userActions.GetUser());
    }
}
